"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var RenamePropertiesReplacer_1;
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenamePropertiesReplacer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const TIdentifierNamesGeneratorFactory_1 = require("../../../types/container/generators/TIdentifierNamesGeneratorFactory");
const IOptions_1 = require("../../../interfaces/options/IOptions");
const IPropertyIdentifierNamesCacheStorage_1 = require("../../../interfaces/storages/identifier-names-cache/IPropertyIdentifierNamesCacheStorage");
const ReservedDomProperties_json_1 = __importDefault(require("../../../constants/ReservedDomProperties.json"));
const NodeGuards_1 = require("../../../node/NodeGuards");
const NodeFactory_1 = require("../../../node/NodeFactory");
let RenamePropertiesReplacer = RenamePropertiesReplacer_1 = class RenamePropertiesReplacer {
    constructor(identifierNamesGeneratorFactory, propertyIdentifierNamesCacheStorage, options) {
        this.excludedPropertyNames = new Set();
        this.propertyNamesMap = new Map();
        this.identifierNamesGenerator = identifierNamesGeneratorFactory(options);
        this.propertyIdentifierNamesCacheStorage = propertyIdentifierNamesCacheStorage;
        this.options = options;
    }
    excludePropertyName(propertyName) {
        this.excludedPropertyNames.add(propertyName);
    }
    replace(node) {
        if (NodeGuards_1.NodeGuards.isPrivateIdentifierNode(node)) {
            return NodeFactory_1.NodeFactory.privateIdentifierNode(this.replacePropertyName(node.name));
        }
        if (NodeGuards_1.NodeGuards.isIdentifierNode(node)) {
            return NodeFactory_1.NodeFactory.identifierNode(this.replacePropertyName(node.name));
        }
        if (NodeGuards_1.NodeGuards.isLiteralNode(node) && typeof node.value === 'string') {
            return NodeFactory_1.NodeFactory.literalNode(this.replacePropertyName(node.value));
        }
        return node;
    }
    replacePropertyName(propertyName) {
        var _a, _b;
        if (this.isReservedName(propertyName)) {
            this.identifierNamesGenerator.preserveName(propertyName);
            return propertyName;
        }
        let renamedPropertyName = this.options.identifierNamesCache
            ? ((_a = this.propertyIdentifierNamesCacheStorage.get(propertyName)) !== null && _a !== void 0 ? _a : null)
            : null;
        renamedPropertyName = (_b = renamedPropertyName !== null && renamedPropertyName !== void 0 ? renamedPropertyName : this.propertyNamesMap.get(propertyName)) !== null && _b !== void 0 ? _b : null;
        if (renamedPropertyName !== null) {
            return renamedPropertyName;
        }
        renamedPropertyName = this.identifierNamesGenerator.generateNext();
        this.propertyNamesMap.set(propertyName, renamedPropertyName);
        if (this.options.identifierNamesCache) {
            this.propertyIdentifierNamesCacheStorage.set(propertyName, renamedPropertyName);
        }
        return renamedPropertyName;
    }
    isReservedName(name) {
        return this.isExcludedName(name) || this.isReservedOptionName(name) || this.isReservedDomPropertyName(name);
    }
    isExcludedName(name) {
        return this.excludedPropertyNames.has(name);
    }
    isReservedOptionName(name) {
        if (!this.options.reservedNames.length) {
            return false;
        }
        return this.options.reservedNames.some((reservedName) => {
            return new RegExp(reservedName, 'g').exec(name) !== null;
        });
    }
    isReservedDomPropertyName(name) {
        return RenamePropertiesReplacer_1.reservedDomPropertiesList.has(name);
    }
};
exports.RenamePropertiesReplacer = RenamePropertiesReplacer;
RenamePropertiesReplacer.reservedDomPropertiesList = new Set(ReservedDomProperties_json_1.default);
exports.RenamePropertiesReplacer = RenamePropertiesReplacer = RenamePropertiesReplacer_1 = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IPropertyIdentifierNamesCacheStorage)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory !== "undefined" && TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory) === "function" ? _a : Object, typeof (_b = typeof IPropertyIdentifierNamesCacheStorage_1.IPropertyIdentifierNamesCacheStorage !== "undefined" && IPropertyIdentifierNamesCacheStorage_1.IPropertyIdentifierNamesCacheStorage) === "function" ? _b : Object, typeof (_c = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _c : Object])
], RenamePropertiesReplacer);
